import type { AgentPresentationStep } from "@/lib/agent-presentation-types";

export const PROMPT_SCREENSHOT_CAPTURE_ID = "__prompt_screenshot__";

export function normalizeSequenceScreenshotTargets(
  value: unknown[],
): AgentPresentationStep[] {
  return value.map((item) => {
    const step = item as Record<string, unknown>;
    const screenshotPoint = step.screenshot_point;
    const screenshotRect = step.screenshot_rect;
    const screenshotPath = step.screenshot_path;
    return {
      ...step,
      ...(screenshotPoint && typeof screenshotPoint === "object"
        ? {
            capture_point: {
              ...screenshotPoint,
              capture_id: PROMPT_SCREENSHOT_CAPTURE_ID,
            },
          }
        : {}),
      ...(screenshotRect && typeof screenshotRect === "object"
        ? {
            capture_rect: {
              ...screenshotRect,
              capture_id: PROMPT_SCREENSHOT_CAPTURE_ID,
            },
          }
        : {}),
      ...(screenshotPath && typeof screenshotPath === "object"
        ? {
            capture_path: {
              ...screenshotPath,
              capture_id: PROMPT_SCREENSHOT_CAPTURE_ID,
            },
          }
        : {}),
    } as AgentPresentationStep;
  });
}
